import { universal } from './db'

export const dbVersion = 1

export const dbMigration = async () => {
  try {
    const isMigrated = localStorage.getItem('dbMigration')
    if (!isMigrated) {
      const dbs = await indexedDB.databases()
      await dbs.forEach((db) => {
        indexedDB.deleteDatabase(db?.name ?? '')
      })
      await universal.recreate()
    }
  } catch (error) {
    console.error('Error migrating database:', error)
  }
}
